import styled from 'styled-components';

export const Export = styled.div`
  width: 105px;
  height: 40px;
  border-radius: 4px;
  align-items: center;
  justify-content: center;
  background: #0db14b;
  display: flex;
  margin-right: 20px;
  font: 500 14px Roboto;
  color: #fff;
  text-decoration: none;
`;
